import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import './productosCarrito.css'

const Producto = ({ producto, recargar }) => {

    const [cantidad, setCantidad] = useState(undefined);


    const handleChangeRestar = () => {
        if (cantidad >= 2) {
            let cantidadNueva = cantidad - 1
            setCantidad(cantidadNueva);
            producto.cantidad = cantidadNueva;
        }
        actualizarLocalStorage()
    }
    const handleChangeSumar = () => {
        let stock = producto.stock ? producto.stock : 1
        if (cantidad < stock) {
            let cantidadNueva = cantidad + 1
            setCantidad(cantidadNueva);
            producto.cantidad = cantidadNueva;
        }
        actualizarLocalStorage()
    };

    const handleDeleteProducto = () => {
        let productosCarrito = JSON.parse(localStorage.getItem('productos')) || [];

        if (productosCarrito && productosCarrito.length > 0) {
            let indiceABorrar = productosCarrito.findIndex(_producto => _producto.idProducto === producto.idProducto && _producto.tipo === producto.tipo)

            if (indiceABorrar > -1) {
                productosCarrito.splice(indiceABorrar, 1);
            }
        }

        localStorage.setItem("productos", JSON.stringify(productosCarrito));
        recargar(true);
    }

    const actualizarLocalStorage = () => {
        let productosCarrito = JSON.parse(localStorage.getItem('productos')) || [];

        if (productosCarrito && productosCarrito.length > 0) {
            const i = productosCarrito.findIndex(_item => _item.idProducto === producto.idProducto && _item.tipo === producto.tipo);
            if (i > -1) productosCarrito[i] = producto;
        }

        localStorage.setItem("productos", JSON.stringify(productosCarrito));
        recargar(true);
    };

    useEffect(() => {
        setCantidad(producto.cantidad ? producto.cantidad : 1)
    }, [producto]);


    if (!producto) return null;

    return (
        <div className="product-border">
            <Row>
                <Col xs={5} className="my-auto px-1 text-center">
                    <img src={producto.imagen} alt={producto.nombreProducto} className="img-fluid mb-3" />
                </Col>
                <Col xs={7} className="my-auto">
                    <h6 className="bold-title-hyundai mb-1 f-responsive">{producto.nombreProducto}</h6>
                    {producto.tipo === "repuesto" && producto.sku &&
                        <p className="parrafo-hyundai mb-1 mb-md-2 f-responsive-10">SKU: {producto.sku && producto.sku}</p>
                    }
                    <p className="parrafo-hyundai f-responsive-10">{producto.descripcionCorta}</p>
                    <p className="parrafo-hyundai mb-0 mb-md-1 f-responsive-10">Normal ${producto.precioNormal} <span className="iva">+IVA</span></p>
                    <h6 className="bold-title-hyundai blue-text-hyundai-carrito f-responsive">Internet: ${producto.precioOferta} <span className="iva">+IVA</span></h6>
                </Col>
            </Row>
            <Row className="mt-2 mb-3">
                <Col xs={6}>
                    <Button className="w-75 btn-secundario d-none d-md-block" onClick={handleDeleteProducto}>Eliminar</Button>
                    <Button className="w-100 btn-secundario font-btn d-md-none" onClick={handleDeleteProducto}>Eliminar</Button>
                </Col>
                <Col xs={6} className="text-center px-0">
                    <button className="btn-unidad-ficha btn-restar" onClick={handleChangeRestar} >-</button>
                    <Input className="input-unidad-hyundai" readOnly value={cantidad} />
                    <button className="btn-unidad-ficha btn-sumar" onClick={handleChangeSumar}>+</button>
                </Col>
            </Row>
        </div>
    );
}

export default Producto;